import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { AiTeammatesMarketingPage } from "@/components/seo/ai-teammates-marketing-page";
import {
	AI_TEAMMATES_MARKETING_FAQ_SCHEMA_ITEMS,
	AI_TEAMMATES_MARKETING_META_DESCRIPTION,
	AI_TEAMMATES_MARKETING_PAGE_TITLE,
} from "@/constants/seo/ai-teammates-marketing-content";
import {
	buildBreadcrumb,
	buildFAQ,
	buildSoftwareApplication,
	buildWebPage,
	jsonLdScript,
} from "@/lib/seo/json-ld";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

export const Route = createFileRoute("/ai-teammates/marketing")({
	head: () => {
		const canonical = getCanonical("/ai-teammates/marketing");
		const meta = buildMetaTags({
			title: "AI Marketing Agents – SEO, PPC & Email Automation",
			description: AI_TEAMMATES_MARKETING_META_DESCRIPTION,
			canonical,
			ogType: "website",
		});

		const schemas = [
			buildWebPage({
				name: AI_TEAMMATES_MARKETING_PAGE_TITLE,
				description: AI_TEAMMATES_MARKETING_META_DESCRIPTION,
				url: canonical,
			}),
			buildFAQ(AI_TEAMMATES_MARKETING_FAQ_SCHEMA_ITEMS),
			buildBreadcrumb([
				{ name: "Home", url: getCanonical("/") },
				{ name: "AI Teammates", url: getCanonical("/ai-teammates") },
				{ name: "Marketing", url: canonical },
			]),
			buildSoftwareApplication({ ratingValue: 4.8, ratingCount: 50, price: "0" }),
		];

		return {
			meta,
			links: buildLinks({ canonical }),
			scripts: schemas.map(jsonLdScript),
		};
	},
	component: AiTeammatesMarketingRouteComponent,
});

function AiTeammatesMarketingRouteComponent() {
	const { pathname } = useLocation();
	const normalizedPath = pathname.replace(/\/+$/, "") || "/";

	if (normalizedPath === "/ai-teammates/marketing") {
		return <AiTeammatesMarketingPage />;
	}

	return <Outlet />;
}
